// extracted by mini-css-extract-plugin
export default {"stack":"EE2WszMT9k97xV6DFK3m","date":"J4OCEbCo6MbKewRoUaf5","uploader":"jHHQYyBhU8Yf1MGO6PWX"};